import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import type { SvgIconComponent } from "@mui/icons-material";

/**
 * 服務代碼 → 圖示。
 *
 * 這**不是**服務清單（那來自 `/me/`），只是「這個前端為哪些服務準備了圖示」。
 * 對不上的服務會拿到通用圖示，不會壞掉 —— 新服務上線時即使忘了加圖示，
 * 導覽也照樣可用。
 */
const SERVICE_ICONS: Record<string, SvgIconComponent> = {
  master: StorageOutlinedIcon,
  aggregate: WarehouseOutlinedIcon,
};

export function serviceIcon(code: string): SvgIconComponent {
  return SERVICE_ICONS[code] ?? WidgetsOutlinedIcon;
}
